var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category-edit"},[_c('edit',{attrs:{"api":"categories","id":_vm.id,"title":"Category","fs":_vm.categoryFields},on:{"saved":_vm.saved}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }